import React from 'react';
import DashboardWikis from '../Dashboard/DashboardWikis';
import DashboardComments from '../Dashboard/DashboardComments';
import DashboardPins from '../Dashboard/DashboardPins';
import DashboardNews from '../Dashboard/DashboardNews';
import { Grid } from 'semantic-ui-react';

const DashboardView = () => {
  return (
    <div id={'dashboard'}>
      <Grid padded>
        <Grid.Row className={'dashboard-rows'} as={'div'}>
          <Grid.Column computer={8} tablet={8} mobile={12} className={'left'}>
            <section className={'wiki'}>
              <div className={'section-header'}>
                <h2 className={'title'}>Wiki</h2>
                <div className={'description'}>Letzten 28 Tage</div>
              </div>
              <div className={'lists'}>
                <DashboardWikis />
              </div>
            </section>
            <section className={'pins'}>
              <div className={'section-header'}>
                <h2 className={'title'}>Wichtige Informationen</h2>
              </div>
              <div className={'lists'}>
                <DashboardPins />
              </div>
            </section>
            <section className={'newest-comments'}>
              <div className={'section-header'}>
                <h2 className={'title'}>Kommentare</h2>
                <div className={'description'}>Letzten 28 Tage</div>
              </div>
              <div className={'lists'}>
                <DashboardComments />
              </div>
            </section>
          </Grid.Column>
          <Grid.Column computer={4} tablet={4} mobile={12} className={'right'}>
            <DashboardNews />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default DashboardView;
